import { StyleSheet } from 'react-native';
import { tokens } from '@airtel/air-design-system';
export var getEngagementCardStyles = () => {
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_4 = _tokens$spacing.SPACING_4;
  return StyleSheet.create({
    card: {
      padding: SPACING_8,
      borderRadius: SPACING_8,
      display: 'flex',
      justifyContent: 'center',
      height: '100%'
    },
    subcontainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      height: '100%'
    },
    pressable: {
      height: '100%'
    },
    inview: {
      height: '100%'
    },
    text: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: SPACING_4,
      textAlign: 'center'
    },
    avatarImgStyle: {
      borderRadius: tokens.spacing.SPACING_0
    }
  });
};